module.exports = __webpack_public_path__ + "static/img/menu1.4f59e3b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/menu1.png
// module id = 1rje
// module chunks = 11